export default __webpack_public_path__ + "media/images/landlords_page/hero-lg-a31dd65c076baf54fff971379393b6a0.png";